import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type IssueType = 'Technical' | 'Account' | 'Sales' | 'Other'

type PlatformType =
  | 'Windows'
  | 'MacOS'
  | 'Linux'
  | 'Android'
  | 'Ios'
  | 'Chrome'
  | 'Firefox'
  | 'Other'

export interface IssueState {
  issueType?: IssueType
  platform?: PlatformType
}

const initialState: IssueState = { issueType: undefined, platform: undefined }

const issueSlice = createSlice({
  name: 'issues',
  initialState: initialState,
  reducers: {
    setIssueType: (state: IssueState, { payload }: PayloadAction<{ issue: IssueType }>) => {
      state.issueType = payload.issue
    },
    setPlatform: (state: IssueState, { payload }: PayloadAction<{ platform: PlatformType }>) => {
      state.platform = payload.platform
    },
    clear: () => initialState,
  },
})

export const { actions: issueActions, reducer: issueReducer } = issueSlice
export default issueSlice
